module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "form",
      rawName: "v-form",
      value: ('back-add-person'),
      expression: "'back-add-person'"
    }],
    staticClass: "z-add-person"
  }, [_c('div', {
    staticClass: "double-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.name),
      expression: "sub.name"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请输入职员姓名"
    },
    model: {
      value: (_vm.sub.name),
      callback: function($$v) {
        _vm.$set(_vm.sub, "name", $$v)
      },
      expression: "sub.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("账号")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap text"
  }, [_vm._v("\n                        " + _vm._s(_vm.sub.account) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("工号")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.job_num),
      expression: "sub.job_num"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请输入职员工号"
    },
    model: {
      value: (_vm.sub.job_num),
      callback: function($$v) {
        _vm.$set(_vm.sub, "job_num", $$v)
      },
      expression: "sub.job_num"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("入职时间")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-date-picker', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.work_date),
      expression: "sub.work_date"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "type": "date",
      "placeholder": "请选择入职日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.sub.work_date),
      callback: function($$v) {
        _vm.$set(_vm.sub, "work_date", $$v)
      },
      expression: "sub.work_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("出生日期")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-date-picker', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.birth_date),
      expression: "sub.birth_date"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "type": "date",
      "placeholder": "请选择出生日期",
      "picker-options": _vm.picker_special
    },
    model: {
      value: (_vm.sub.birth_date),
      callback: function($$v) {
        _vm.$set(_vm.sub, "birth_date", $$v)
      },
      expression: "sub.birth_date"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("手机号码")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.phone_num),
      expression: "sub.phone_num"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal phone",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.sub.phone_num),
      callback: function($$v) {
        _vm.$set(_vm.sub, "phone_num", $$v)
      },
      expression: "sub.phone_num"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("职位属性")]), _vm._v(" "), _c('div', {
    staticClass: "double-wrap"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("岗位")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.position_id),
      expression: "sub.position_id"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "clearable": "",
      "placeholder": "请选择岗位"
    },
    model: {
      value: (_vm.sub.position_id),
      callback: function($$v) {
        _vm.$set(_vm.sub, "position_id", $$v)
      },
      expression: "sub.position_id"
    }
  }, _vm._l((_vm.post_list), function(item) {
    return _c('z-limitOption', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.positionName
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("职级")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('el-input', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.rank),
      expression: "sub.rank"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "placeholder": "请输入职级"
    },
    model: {
      value: (_vm.sub.rank),
      callback: function($$v) {
        _vm.$set(_vm.sub, "rank", $$v)
      },
      expression: "sub.rank"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("级")])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("所属BU")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap",
    class: {
      text: _vm.id
    }
  }, [(_vm.id) ? _c('div', [_vm._v(_vm._s(_vm.bu_name))]) : _c('el-select', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.sub.bu_id),
      expression: "sub.bu_id"
    }],
    staticClass: "top-choose z-mid",
    attrs: {
      "rule": "noVal",
      "clearable": "",
      "placeholder": "请选择所属BU"
    },
    model: {
      value: (_vm.sub.bu_id),
      callback: function($$v) {
        _vm.$set(_vm.sub, "bu_id", $$v)
      },
      expression: "sub.bu_id"
    }
  }, _vm._l((_vm.bu_list), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.buName
      }
    })
  }))], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "back-item"
  }, [_c('div', {
    staticClass: "back-title"
  }, [_vm._v("角色设置")]), _vm._v(" "), _c('div', {
    staticClass: "back-wrap"
  }, [_c('div', {
    staticClass: "check-head"
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.chooseAll
    },
    model: {
      value: (_vm.check_all),
      callback: function($$v) {
        _vm.check_all = $$v
      },
      expression: "check_all"
    }
  }, [_vm._v(_vm._s("全选"))])], 1), _vm._v(" "), _c('el-checkbox-group', {
    directives: [{
      name: "tar",
      rawName: "v-tar",
      value: (_vm.role_str),
      expression: "role_str"
    }],
    staticClass: "role-wrap",
    on: {
      "change": _vm.roleCheck
    },
    model: {
      value: (_vm.sub.role_ids),
      callback: function($$v) {
        _vm.$set(_vm.sub, "role_ids", $$v)
      },
      expression: "sub.role_ids"
    }
  }, _vm._l((_vm.role_list), function(item) {
    return _c('el-checkbox', {
      key: item.id,
      staticClass: "role-item",
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.displayName))])
  }))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "back-btn blue",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "back-btn",
    class: {
      disabled: !_vm.now_form.changeFlag
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-f2add01e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/person-detail/tab/person-info.vue
// module id = 795
// module chunks = 1